import React from 'react';
import background from '../../assets/krill.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoKrill extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        subtag="FOOD WEB"
        description="Krill"
        paragraph="Krill – a shrimp-like crustacean – forms the basis of the marine food web for whales, seabirds, fish, squid, seals, and sharks throughout the world’s oceans."
        background={background}
     />
  
  );
 }
}   

export default InfoKrill;